import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'quotaStyle'
})
export class QuotaStylePipe implements PipeTransform {
  transform(amount: number, numberAlwaysVisible: boolean): string {
    if (amount > 0) {
      return 'success-inverted';
    }

    if (amount === 0 && numberAlwaysVisible) {
      return 'moderate-inverted';
    }

    return 'negative-inverted';
  }
}
